import { useTranslation } from 'react-i18next';

import { buildManualUrl, type ManualTarget } from '@/shared/config/manual';

/** Resolves a manual target to a URL in the currently selected language. */
export function useManualUrl(target?: ManualTarget | null): string | undefined {
  const { i18n } = useTranslation();

  return target == null ? undefined : buildManualUrl(i18n.language, target);
}
